import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';

import InfoIcon from '@material-ui/icons/Info';
import {
    LibraryAdd as AddSiteCardIcon
    // ExitToAppIcon as ViewSiteCardIcon
} from '@material-ui/icons';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { Box, IconButton, Switch, Tooltip, Typography } from '@material-ui/core';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { setOrCreateNewActiveLayer } from '../../../../redux/active_layers/Actions';
import PanelHeader from '../PanelHeader';
import { setMapProperties } from '../../../../redux/map/Actions';
import { MAIN_MAP } from '../../../../redux/map/Constants';
import { Link } from 'react-router-dom';
import CreateSiteCardDialog from '../../../Common/SiteCard/CreateDialog';

class PropertyInfoHeader extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        isCompact: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        // Redux State
        id: PropTypes.any,
        title: PropTypes.string,
        parcelLayer: PropTypes.object, // Not required since not immediately available
        settings: PropTypes.object,
        isLayerActive: PropTypes.bool.isRequired,
        siteCard: PropTypes.object,
        features: PropTypes.object.isRequired,
        selectedPolygon: PropTypes.object,
        // Redux Dispatch
        dispatchSetParcelLayerActive: PropTypes.func.isRequired,
        dispatchSetMapProperties: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            isCreateSiteCardDialogOpen: false
        };

        this.toggleParcelLayer = this.toggleParcelLayer.bind(this);
        this.openCreateSiteCardDialog = this.openCreateSiteCardDialog.bind(this);
        this.closeCreateSiteCardDialog = this.closeCreateSiteCardDialog.bind(this);
        this.viewSiteCard = this.viewSiteCard.bind(this);
    }

    toggleParcelLayer (event) {
        const { parcelLayer, settings, dispatchSetParcelLayerActive, dispatchSetMapProperties } = this.props;

        if (!parcelLayer) { return; }

        const activeLayer = {
            uid: parcelLayer.system_name,
            systemName: parcelLayer.system_name,
            visible: event.target.checked,
            printable: true
        };
        dispatchSetParcelLayerActive(activeLayer, parcelLayer);
        if (event.target.checked) { dispatchSetMapProperties({ zoom: [parcelLayer.styles[(settings && settings.currentStyleIdx) || 0].mapboxStyleSpecification.source.minzoom + 1] }); }
    }

    openCreateSiteCardDialog () {
        this.setState({ isCreateSiteCardDialogOpen: true });
    }

    closeCreateSiteCardDialog () {
        this.setState({ isCreateSiteCardDialogOpen: false });
    }

    viewSiteCard () {
        console.log('Go to dashboard here');
    }

    render () {
        const { classes, isCompact, onClick, isLayerActive, id, title, parcelLayer, siteCard, features, selectedPolygon } = this.props;
        const { isCreateSiteCardDialogOpen } = this.state;
        // ToDo if user does not have to dashboard then this prevents them going to dashboard
        return (
            <>
                { id && title && <CreateSiteCardDialog
                    open={isCreateSiteCardDialogOpen}
                    onClose={this.closeCreateSiteCardDialog}
                    featureConfig={{
                        layerId: parcelLayer.id,
                        featureId: id
                    }}
                    defaultName={title}
                />}
                <PanelHeader
                    isCompact={isCompact}
                    isExpandable={Boolean(title)}
                    onClick={onClick}
                >
                    {
                        (title) ?
                            <>
                                <Typography
                                    className={classes.text}
                                    variant="h4"
                                    color="secondary"
                                >
                                    <InfoIcon
                                        className={classes.icon}
                                    />
                                    { `Title No. ${title}`}
                                </Typography>
                                {
                                    !siteCard && Boolean(features.siteCard && features.siteCard.enabled) &&
                                        <Tooltip arrow title="Create Site Card" placement="right">
                                            <Box color="primary.contrastText">
                                                <IconButton
                                                    onClick={this.openCreateSiteCardDialog}
                                                    disabled={selectedPolygon?.isLite || selectedPolygon?.isFetchingPolygon || selectedPolygon?.isFetchingIntersections || selectedPolygon?.isFetchingAreaInfo}
                                                >
                                                    <AddSiteCardIcon />
                                                </IconButton>
                                            </Box>
                                        </Tooltip>

                                }
                                {
                                    siteCard && Boolean(features.site_card_kanban && features.site_card_kanban.enabled) &&
                                        <Link to={`/dashboard/sites/${siteCard.id}`}>
                                            <Tooltip arrow title="View Site Card" placement="right">
                                                <Box color="primary.light">
                                                    <IconButton
                                                        color="inherit"
                                                        onClick={()=>{}}
                                                    >
                                                        <ExitToAppIcon />
                                                    </IconButton>
                                                </Box>
                                            </Tooltip>
                                        </Link>
                                }
                            </> :
                            <>

                                <Typography
                                    className={classes.text}
                                    variant="h4"
                                    color="textPrimary"
                                >
                                    <InfoIcon
                                        className={classes.icon}
                                    />
                                    {
                                        isLayerActive ?
                                            'Select a tile to view more information' :
                                            'Activate HMLR to begin'
                                    }

                                </Typography>
                                <Switch
                                    classes={{
                                        root: classes.switchRoot
                                    }}
                                    checked={isLayerActive}
                                    onChange={this.toggleParcelLayer}
                                />
                            </>
                    }
                </PanelHeader>
            </>
        );
    }
}

const style = theme => ({
    text: {
        display: 'flex',
        alignItems: 'center'
    },
    icon: {
        marginRight: theme.constants.horizontalMargin
    },
    switchRoot: {
        marginLeft: 'auto'
    }
});

const mapStateToProps = (state, ownProps) => {
    let isLayerActive = Boolean(state.activeLayers.find(e => e.systemName === 'hmlr_land_parcels'));
    const currentPolygon = state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
    const layer = state.layers.layers.find(e => e.system_name === 'hmlr_land_parcels');
    const settings = state.layerSettingsReducer.find(setting => setting.uid === layer.system_name);

    // Dirty logic for checking if layer is active through site finder
    if (state.panels.panels.search_enhanced.enabled) {
        const search = state.search.search;
        if (search && search.computedData && search.computedData.length > 0) {
            isLayerActive = true;
        }
    }

    const siteCard = state.siteCard.siteCards.find(el => el.layerId === layer.id && el.featureId === state.parcelPanel.currentPolygonId);

    return {
        id: state.parcelPanel.currentPolygonId,
        title: (currentPolygon && currentPolygon.titleNo),
        isLayerActive: isLayerActive,
        parcelLayer: layer,
        settings: settings,
        siteCard: siteCard,
        features: state.user.features,
        selectedPolygon: currentPolygon
    };
};

const mapDispatchToProps = dispatch => ({
    dispatchSetParcelLayerActive: (activeLayer, layer) => dispatch(setOrCreateNewActiveLayer(activeLayer, layer)),
    dispatchSetMapProperties: (properties) => dispatch(setMapProperties(properties, MAIN_MAP))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(PropertyInfoHeader);
